import {Box} from "@mui/material";
import BidItemBottomGrid from "./BidItemBottomGrid";
import BidItemRightTable from "./BidItemRightTable";
import BidItemLeftTable from "./BidItemLeftTable";

const BidItem = ({item, rfqDetails, setBidMainId}) => {
    return (
        <Box display="flex" flexDirection="column">
            <Box display="flex">
                <BidItemLeftTable item={item} rfqDetails={rfqDetails} setBidMainId={setBidMainId}/>
                <BidItemRightTable item={item} rfqDetails={rfqDetails}/>
            </Box>
            <BidItemBottomGrid item={item}/>
        </Box>
    )
}

export default BidItem
